export default __webpack_public_path__ + "static/media/cannibals.2dcdcbb0.png";